.sub {
  font-size: 12px;
  color: var(--muted);
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.defaultBadge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border: 1px solid var(--accent);
  border-radius: 999px;
  font-size: 12px;
  color: var(--accent);
}

.create {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}

.create input {
  flex: 1;
  min-width: 0;
}

.form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.wide {
  grid-column: 1 / -1;
}

.switch {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.hint {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--muted);
}

.error {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--danger);
}

.back {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.backImg {
  width: 110px;
  aspect-ratio: 180 / 314;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--pill-bg);
  display: grid;
  place-items: center;
  font-size: 12px;
  color: var(--muted);
  text-align: center;
}

img.backImg {
  border: 0;
  border-radius: 0;
  background: none;
  object-fit: contain;
}

.backActions {
  display: grid;
  gap: 10px;
}

.backLib {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.backItem {
  position: relative;
}

.backPick {
  padding: 0;
  width: 56px;
  aspect-ratio: 180 / 314;
  border-radius: 8px;
  overflow: hidden;
  background: transparent;
  box-shadow: inset 0 0 0 1px var(--line);
}

.backPick[aria-pressed='true'] {
  box-shadow: 0 0 0 2px var(--accent);
}

.backRemove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 14px;
  line-height: 1;
  color: var(--text);
  background: var(--surface);
  box-shadow: inset 0 0 0 1px var(--line);
}

.backRemove:hover:not(:disabled) {
  color: var(--danger);
}

.backPick img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.drop {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 8px 8px 14px;
  margin-bottom: 12px;
  border: 1px dashed var(--line);
  border-radius: 16px;
  font-size: 13px;
  color: var(--muted);
}

.drop > span {
  flex: 1;
  min-width: 0;
}

.drop[data-over='true'] {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, transparent);
  color: var(--text);
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(64px, 1fr));
  gap: 10px 8px;
}

.slot {
  position: relative;
  display: grid;
  gap: 6px;
  padding: 0;
  background: transparent;
  color: var(--text);
  font-weight: 400;
  border-radius: 10px;
  min-width: 0;
}

.slotImg {
  position: relative;
  aspect-ratio: 180 / 314;
  border-radius: 10px;
  border: 1px solid var(--line);
  overflow: hidden;
  display: grid;
  place-items: center;
  text-align: center;
  font-family: var(--font-display, inherit);
  font-size: 22px;
  color: var(--muted);
}

.slotImg img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.slotEmpty .slotImg {
  border-style: dashed;
}

.slot:hover .slotImg {
  border-color: var(--accent);
}

.slotName {
  font-size: 11px;
  line-height: 1.3;
  color: var(--muted);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.slotRemove {
  justify-self: center;
  padding: 2px 10px;
  font-size: 12px;
}

.tabs {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: var(--pill-bg);
  box-shadow: inset 0 0 0 1px var(--line);
}

.tabs button {
  padding: 5px 13px;
  font-size: 13px;
  background: transparent;
  color: var(--muted);
}

.tabs button[aria-pressed='true'] {
  background: var(--fill);
  color: var(--on-fill);
}

.queue {
  margin: 0 0 12px;
  padding-left: 18px;
  font-size: 13px;
  color: var(--muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (max-width: 640px) {
  .form {
    grid-template-columns: minmax(0, 1fr);
  }

  .back {
    grid-template-columns: minmax(0, 1fr);
  }
}

.slot[aria-pressed='true'] .slotImg {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--accent);
}

.own {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 1px 7px;
  border-radius: 999px;
  background: var(--fill);
  color: var(--on-fill);
  font-family: var(--font-body, inherit);
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.eyebrow {
  display: block;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.kinds {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.kind {
  display: grid;
  align-content: start;
  gap: 6px;
  padding: 14px;
  border-radius: 16px;
  text-align: left;
  font-weight: 400;
  background: transparent;
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--line);
}

.kind[aria-checked='true'] {
  box-shadow: inset 0 0 0 2px var(--accent);
}

.kind b {
  font-weight: 500;
}

.kind ul {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  color: var(--muted);
}

.field {
  display: grid;
  gap: 6px;
  color: var(--muted);
  font-size: 13px;
}

.editGrid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 16px;
  align-items: start;
}

.cardForm {
  display: grid;
  gap: 12px;
}

.cardForm h2 {
  margin: 2px 0 0;
}

.formTitle {
  font-weight: 500;
  font-size: 14px;
}

@media (max-width: 900px) {
  .kinds,
  .editGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.editorLayout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 440px;
  gap: 16px;
  align-items: start;
}

.main {
  min-width: 0;
}

.main > section {
  margin-bottom: 0;
}

.side {
  position: sticky;
  top: 12px;
  display: grid;
  gap: 12px;
  max-height: calc(100vh - 24px);
  overflow-y: auto;
  scrollbar-width: none;
}

.pop .back {
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 12px;
}

.pop .backImg {
  width: 72px;
}

.pop .backActions {
  gap: 8px;
}

.pop .backPick {
  width: 36px;
}

.sideBlock {
  display: grid;
  gap: 8px;
}

.sideHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.sideHead h3 {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.sheet {
  position: relative;
}

.sheetClose {
  display: none;
}

.gridWrap {
  position: relative;
}

.gridOverlay {
  position: absolute;
  inset: -6px;
  z-index: 2;
  display: grid;
  place-content: center;
  gap: 4px;
  padding: 16px;
  text-align: center;
  border: 2px dashed var(--accent);
  border-radius: 16px;
  background: color-mix(in srgb, var(--bg) 80%, transparent);
  pointer-events: none;
}

.gridOverlay b {
  font-family: var(--font-display, inherit);
  font-size: 18px;
  font-weight: 500;
}

.gridOverlay span {
  font-size: 13px;
  color: var(--muted);
}

.divider,
.fullRow {
  grid-column: 1 / -1;
}

.divider {
  border-top: 1px dashed var(--line);
}

.slot[data-over='true'] .slotImg,
.backDrop[data-over='true'] .backImg {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--accent), 0 0 0 6px color-mix(in srgb, var(--accent) 20%, transparent);
}

.slot[data-over='true'] .slotImg::after,
.slot[data-state='bad'] .slotImg::after {
  content: attr(data-hint);
  position: absolute;
  inset: auto 0 0;
  z-index: 1;
  padding: 3px 0;
  font-family: var(--font-body, inherit);
  font-size: 11px;
  font-weight: 600;
  background: var(--fill);
  color: var(--on-fill);
}

.slot[data-state='bad'] .slotImg,
.backDrop[data-state='bad'] .backImg {
  border-color: var(--danger);
  box-shadow: 0 0 0 2px var(--danger);
}

.slot[data-state='bad'] .slotImg::after {
  content: 'Ошибка';
  background: var(--danger);
  color: #fff;
}

.slot[data-state='busy'] .slotImg::before,
.backDrop[data-state='busy']::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  background: color-mix(in srgb, var(--bg) 55%, transparent) linear-gradient(90deg, transparent, color-mix(in srgb, var(--accent) 35%, transparent), transparent) no-repeat;
  background-size: 200% 100%;
  animation: shimmer 1.2s linear infinite;
}

.backDrop {
  position: relative;
  border-radius: 10px;
}

.slot[data-state='done'] .slotImg::after {
  content: '✓';
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  font-family: var(--font-body, inherit);
  font-size: 11px;
  background: var(--success, #3f9a5d);
  color: #fff;
}

@keyframes shimmer {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .slot[data-state='busy'] .slotImg::before,
  .backDrop[data-state='busy']::before {
    animation: none;
  }

  .slot[data-over='true'] .slotImg {
    transform: none;
  }
}

@media (prefers-reduced-motion: no-preference) {
  .slot[data-over='true'] .slotImg {
    transform: scale(1.04);
    transition: transform 0.12s;
  }
}

@media (max-width: 1080px) {
  .editorLayout {
    grid-template-columns: minmax(0, 1fr);
  }

  .side {
    position: static;
    max-height: none;
    overflow: visible;
  }

  .sheet {
    position: fixed;
    inset: auto 0 0;
    z-index: 30;
    max-height: 82vh;
    overflow-y: auto;
    padding: 8px max(8px, env(safe-area-inset-right, 0px)) calc(8px + env(safe-area-inset-bottom, 0px)) max(8px, env(safe-area-inset-left, 0px));
    border-radius: 20px 20px 0 0;
    background: var(--bg-raised);
    box-shadow: 0 -16px 40px rgb(0 0 0 / 35%);
  }

  .sheetClose {
    display: grid;
    place-items: center;
    position: sticky;
    top: 0;
    z-index: 2;
    width: 32px;
    height: 32px;
    padding: 0;
    margin-left: auto;
    border-radius: 50%;
  }
}

.toolbarWrap {
  display: grid;
  gap: 10px;
  margin-bottom: 20px;
}

.crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--muted);
}

.crumb button {
  padding: 0;
  font-size: 13px;
  font-weight: 400;
  background: transparent;
  color: var(--muted);
}

.crumb button:hover {
  opacity: 1;
  color: var(--accent);
}

.allDecks {
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--line);
  transition: box-shadow 0.15s ease;
}

.allDecks:hover {
  box-shadow: inset 0 0 0 1px var(--accent);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  padding: 10px 12px;
  border-radius: 20px;
  background: color-mix(in srgb, var(--surface) 88%, transparent);
  box-shadow: inset 0 0 0 1px var(--line);
}

.popRoot {
  position: relative;
}

.pop {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 20;
  display: grid;
  gap: 10px;
  width: min(380px, calc(100vw - 32px));
  padding: 14px;
  border-radius: 16px;
  background: var(--surface);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 18px 40px rgb(0 0 0 / 30%);
}

.pop[data-align='end'] {
  left: auto;
  right: 0;
}

.popMenu {
  width: 240px;
  gap: 2px;
  padding: 6px;
}

.popMenu button {
  padding: 9px 12px;
  border-radius: 10px;
  text-align: left;
  font-weight: 400;
  background: transparent;
  color: var(--text);
}

.popMenu button:hover {
  opacity: 1;
  background: var(--pill-bg);
}

.popMenu .menuDanger {
  color: var(--danger);
}

.backTrigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px 4px 4px;
  border-radius: 10px;
  font-size: 12px;
  background: transparent;
  color: var(--muted);
}

.backTrigger:hover {
  opacity: 1;
  background: var(--pill-bg);
}

.backTrigger img,
.backStd {
  display: block;
  width: 30px;
  aspect-ratio: 180 / 314;
  border-radius: 5px;
  object-fit: contain;
  box-shadow: 0 0 0 1px var(--line);
}

.backTrigger img {
  border-radius: 0;
  box-shadow: none;
}

.backStd {
  background: linear-gradient(120deg, var(--line), var(--accent), var(--line));
}

.title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  margin: 0;
  font-size: 26px;
  overflow-wrap: anywhere;
}

.pen {
  padding: 4px 6px;
  font-size: 16px;
  background: transparent;
  color: var(--muted-dim);
}

.pen:hover {
  opacity: 1;
  color: var(--accent);
}

.rename {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.rename input {
  width: min(320px, 100%);
}

.sep {
  align-self: stretch;
  width: 1px;
  background: var(--line);
}

.grow {
  flex: 1;
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 4px 2px;
  font-weight: 400;
  background: transparent;
  color: var(--text);
}

.toggle:hover {
  opacity: 1;
}

.toggle i {
  position: relative;
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: var(--line);
  transition: background-color 0.2s ease;
}

.toggle i::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--text);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease;
}

.toggle[aria-checked='true'] i {
  background: var(--ok);
}

.toggleGold[aria-checked='true'] i {
  background: var(--accent);
}

.toggle[aria-checked='true'] i::after {
  transform: translateX(16px);
  background: #fff;
}

.more {
  width: 38px;
  height: 38px;
  padding: 0;
  border-radius: 12px;
  font-size: 18px;
  line-height: 1;
}

.toolbarSub {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin: 0;
  padding-left: 4px;
  font-size: 14px;
  color: var(--muted);
}

.describe {
  display: grid;
  gap: 10px;
  padding: 14px;
  border-radius: 16px;
  box-shadow: inset 0 0 0 1px var(--line);
}

.slotTools {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.slot:hover .slotTools,
.slot:focus-within .slotTools {
  opacity: 1;
}

.slotTools button {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  font-size: 13px;
  line-height: 1;
  background: rgb(16 12 8 / 78%);
  color: #f5ecdb;
}

.slotTools button:hover:not(:disabled) {
  opacity: 1;
  background: var(--accent);
  color: var(--on-fill);
}

.preview {
  display: grid;
  justify-items: center;
  padding: 4px 0 8px;
}

.preview > img {
  width: 220px;
  max-width: 100%;
  height: auto;
  aspect-ratio: 180 / 314;
  object-fit: contain;
}

@media (hover: none) {
  .slotTools {
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .sep,
  .grow {
    display: none;
  }

  .title {
    flex: 1 1 100%;
    order: -1;
    font-size: 22px;
  }

  .rename {
    flex: 1 1 100%;
    order: -1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .toggle i,
  .toggle i::after,
  .slotTools {
    transition: none;
  }
}


.textEdit {
  padding: 14px 16px 18px;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: var(--surface);
}
